import * as React from "react"
import { forwardRef, RefObject } from "react"
import { Size } from "../../types/Size"
import { WithEvents, WithEventsProperties } from "../../../components/hoc/WithEvents"
import { DeprecatedFrame, DeprecatedCoreFrameProps } from "./DeprecatedFrame"
import { FrameWithMotion, FrameProps } from "./FrameWithMotion"
import { useParentSize, deprecatedParentSize } from "../../types/NewConstraints"
import { isDeprecatedFrameProps } from "./isDeprecatedFrameProps"
export { isDeprecatedFrameProps } from "./isDeprecatedFrameProps"
// Re-exports
export { DeprecatedFrame } from "./DeprecatedFrame"
export type { DeprecatedCoreFrameProps, DeprecatedFrameProperties } from "./DeprecatedFrame"
export { FrameWithMotion } from "./FrameWithMotion"
export type { FrameProps } from "./FrameWithMotion"
export type { BaseFrameProps, FrameLayoutProperties, CSSTransformProperties, VisualProperties } from "./types"

// Public types
/** @public */
export type DeprecatedFrameWithEventsProps = DeprecatedCoreFrameProps & WithEventsProperties
/** @public */
export const DeprecatedFrameWithEvents: React.ComponentClass<Partial<DeprecatedFrameWithEventsProps>> = WithEvents(
    DeprecatedFrame
)

// const isPreview = RenderEnvironment.target === RenderTarget.preview

// We need switcher component to useContext without conditions
// THIS SHOULD NOT BE USED DIRECTLY IN LIBRARY NOR IN VEKTER
// Only for backwards compatibility
/** @public */
export const Frame = forwardRef(function Frame(props: Partial<FrameProps>, ref: RefObject<HTMLDivElement> | null) {
    const parentSize = useParentSize()
    if (isDeprecatedFrameProps(props)) {
        const currentParentSize: Size | null = props.parentSize || deprecatedParentSize(parentSize)

        // We use here DeprecatedFrame WithEvents for simplicity
        return <DeprecatedFrameWithEvents {...props} parentSize={currentParentSize} />
    }
    return <FrameWithMotion {...props} ref={ref} />
})
